module.exports = __webpack_public_path__ + "static/img/team_honor_jijun.e9ea4a9d.png";